import { Lawsuit } from "types/OnDemand.types";
export type ProcessesSummary = {
  valid: Lawsuit[];
};
export const useSearchProcessesSummary = (rows: Lawsuit[]) => {
  //   const rows = percomp.filter(getrows);
  return {
    valid: rows,
    // ipi: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.RessarcimentoDeIPI,
    // ),
    // pis: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.PISPASEPNaoCumulativo,
    // ),
    // confins: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.CofinsNaoCumulativa,
    // ),
    // pagementoMaiorIndevido: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.PagamentoIndevidoOuAMaior,
    // ),
    // sncsll: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.SaldoNegativoDeCSLL,
    // ),
    // snirpj: rows.filter(
    //   (r) => r.tipoCredito == PerdcompTipoCredito.SaldoNegativoDeIRPJ,
    // ),
    // salarioFamiliaMaternidade: rows.filter(
    //   (r) =>
    //     r.tipoCredito == PerdcompTipoCredito.SalarioFamiliaSalarioMaternidade,
    // ),
  } as ProcessesSummary;
};
